
import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-background border-t">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="text-ride-primary font-bold text-2xl mb-4">ParleyRide</div>
            <p className="text-muted-foreground">
              Your on-demand transportation solution with fair, negotiable pricing directly between riders and drivers.
            </p>
          </div>
          
          <div>
            <h3 className="font-medium text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              <li><Link to="/about-us" className="text-muted-foreground hover:text-foreground transition-colors">About Us</Link></li>
              <li><Link to="/how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">How It Works</Link></li>
              <li><Link to="/contact-us" className="text-muted-foreground hover:text-foreground transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-lg mb-4">Services</h3>
            <ul className="space-y-2">
              <li><Link to="/driver-signup" className="text-muted-foreground hover:text-foreground transition-colors">Drive with Us</Link></li>
              <li><Link to="/rides" className="text-muted-foreground hover:text-foreground transition-colors">My Rides</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-medium text-lg mb-4">Support</h3>
            <ul className="space-y-2">
              <li><Link to="/faq" className="text-muted-foreground hover:text-foreground transition-colors">FAQ</Link></li>
              <li><Link to="/safety" className="text-muted-foreground hover:text-foreground transition-colors">Safety</Link></li>
              <li><Link to="/contact-us" className="text-muted-foreground hover:text-foreground transition-colors">Contact</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t mt-10 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} ParleyRide. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
